import { useEffect, useState } from "react";
import api, { resolveAssetUrl } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";
import { ExternalLink } from "lucide-react";

export default function Partners() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/partners").then((r) => Array.isArray(r.data) && setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-5 py-12" data-testid="partners-page">
      <SectionHeader title="Nasi znajomi" />
      <p className="text-center mt-4 mb-10" style={{ color: "var(--sr-cream-soft)" }}>
        Kluby, akcje i ludzie, z którymi jeździmy i z którymi nas coś łączy.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((p, i) => (
          <a
            key={p.id}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            className="sr-card p-5 group hover:-translate-y-1 transition-transform fade-up"
            style={{ animationDelay: `${(i % 6) * 70}ms` }}
            data-testid={`partner-${p.id}`}
          >
            <div className="flex items-center gap-4">
              {p.logo_url ? (
                <img
                  src={resolveAssetUrl(p.logo_url)}
                  alt={p.name}
                  style={{ width: 64, height: 64, objectFit: "contain", flexShrink: 0, background: "rgba(0,0,0,0.3)", border: "1px solid var(--sr-border)", padding: 4 }}
                />
              ) : (
                <div className="flex-shrink-0 flex items-center justify-center" style={{ width: 64, height: 64, background: "rgba(255,106,26,0.08)", border: "1px solid var(--sr-border)" }}>
                  <ExternalLink className="text-[var(--sr-fire)]" size={22} />
                </div>
              )}
              <div className="min-w-0 flex-1">
                <h3 className="font-display text-lg text-[var(--sr-cream)] group-hover:text-[var(--sr-fire)] transition-colors truncate">
                  {p.name}
                </h3>
                <p className="text-xs font-nav uppercase tracking-widest mt-1" style={{ color: "var(--sr-fire-2)" }}>
                  {(p.url || "").replace(/^https?:\/\//, "").split("/")[0]}
                </p>
              </div>
            </div>
            {p.description && (
              <p className="mt-3 text-sm" style={{ color: "var(--sr-cream-soft)" }}>{p.description}</p>
            )}
          </a>
        ))}
        {items.length === 0 && (
          <p className="col-span-full text-center" style={{ color: "var(--sr-muted)" }}>
            Lista znajomych wkrótce.
          </p>
        )}
      </div>
    </div>
  );
}
